<template>
  <div class="message-box dialog-mask" @click.self="onClickOutSide">
    <div class="dialog-content">
      <h2 :style="{ textAlign: 'center' }">{{ title }}</h2>
      <div class="dialog-body">
        <div v-html="content" />
      </div>
      <footer>
        <div class="button-area">
          <button class="button cancel" @click="onNegativeClick">{{ negative || $t('common.cancel') }}</button>
          <button class="button danger" @click="onPositiveClick">{{ positive || $t('common.yes') }}</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<{}, Methods, {}, Props>({
  methods: {
    onNegativeClick() {
      if (this.negativeCallback) {
        this.negativeCallback();
      }

      this.$close(true);
    },
    onPositiveClick() {
      if (this.positiveCallback) {
        this.positiveCallback();
      }

      this.$close(true);
    },
    onClickOutSide() {
      this.$close(true);
    },
  },
  props: {
    title: String,
    content: String,
    negative: {
      type: String,
      default: undefined,
    },
    negativeCallback: Function,
    positive: {
      type: String,
      default: undefined,
    },
    positiveCallback: Function,
  },
});

interface Methods {
  onClickOutSide: () => void;
  onNegativeClick: () => void;
  onPositiveClick: () => void;
}

interface Props {
  title: string;
  content: string;
  negative?: string;
  positive?: string;
  negativeCallback?: () => void;
  positiveCallback?: () => void;
}

export type SimpleDialogProps = Props;
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

header {
  font-weight: var(--font-weight-bold);
  font-size: large;
  margin: 15px auto;
}

.button-area {
  margin: 10px auto;
  float: right;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.dialog-body {
  font-size: larger;
  display: flex;
  align-items: flex-start;
  white-space: pre-wrap;
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xs);
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-lg);
  color: var(--color-text-normal);
  max-width: 300px;
}

.button {
  position: relative;

  &.cancel {
    background-color: var(--color-surface-muted);
    color: var(--color-text-normal);
    border: 1px solid var(--color-border);

    @include hover-overlay;
  }

  &.danger {
    background-color: var(--color-warning);
    color: var(--color-text-on-fixed-bg);

    @include hover-overlay;
  }
}
</style>
